module.exports = __webpack_public_path__ + "static/media/fit-awards-img.6954be2a.png";